import * as angular from 'angular';
import * as moment from 'moment';
import { CommonCampaignsService } from '../../modules/services/commonCampaigns.service';

interface ICampaignActiveTime {
    DailyStartTime: string;
    DailyEndTime: string;
}


class CampaignActiveTime {
    static $inject = ['commonCampaignsService', '$translate'];
    activeTime: string;
    allDaily: boolean;
    private startTime: string;
    private endTime: string;
    private readonly defaultStartTime = '12:00 AM';
    private readonly defaultEndTime = '12:00 PM';
    private readonly minTime = '00:00';

    constructor(private campaignsService: CommonCampaignsService, private $translate: angular.translate.ITranslateService) {
    }

    $onChanges(changes: any) {

        this.allDaily = !this.endTime && !this.startTime;

        let startTime = this.startTime ? this.getTime(this.startTime === this.minTime ? this.defaultStartTime : this.startTime) : this.defaultStartTime;
        let endTime = this.endTime ? this.getTime(this.endTime === this.minTime ? this.defaultEndTime : this.endTime) : this.defaultEndTime;

        if ((startTime === this.defaultStartTime && endTime === this.minTime) ||
            (startTime === this.minTime && endTime === this.defaultEndTime) ||
            (startTime === endTime)
        ) {
            this.allDaily = true;
        }

        this.activeTime = this.allDaily
            ? this.$translate.instant('active_all_day')
            : this.$translate.instant('active_between', { startTime: startTime, endTime: endTime });
    }
    private getTime(stringTime: string) {
        return moment(this.campaignsService.getDateTime(null, stringTime)).format('hh:mm A');
    }
}

angular
    .module('app.retailes.common')
    .component('campaignActiveTime', {
        template: require('./campaign-active-time.html'),
        controller: CampaignActiveTime,
        controllerAs: 'vm',
        bindings: {
            startTime: '<',
            endTime: '<'
        }
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer.common/components/campaign-active-time/campaign-active-time.component.ts